export function checkOverflow(target: HTMLElement, container: HTMLElement, axis: string) {
    let isOverflowing = false;

    switch (axis.toLowerCase()) {
        case "x":
            isOverflowing = $(target).css('width') > $(container).css('width');
            break;
        case "y":
            isOverflowing = $(target).css('height') > $(container).css('height');
            break;
        default:
            isOverflowing = false;
            break;
    }

    return isOverflowing;
}